import React, {useContext, useMemo} from 'react';
import './ResultsWidget.scss';
import ResultsTable from './ResultsTable/ResultsTable';
import {CurrentRaceEventContext} from "../../context/currentRaceEvent.context";
import {ContentProxyRaceDay, ContentProxyRaceDayStatus} from "../../models/contentProxyModel";

const ResultsWidget = () => {
    const {currentEvent} = useContext(CurrentRaceEventContext);

    const isLiveEvent = useMemo(() => {

        if (!currentEvent?.raceDays) {
            return false;
        }
        const liveEventItem = currentEvent?.raceDays?.find(
            (raceDay: ContentProxyRaceDay) =>
                raceDay.state === ContentProxyRaceDayStatus.InProgress
        );
        return !!liveEventItem

    }, [currentEvent?.raceDays]);


    return (
        <div className="resultsWidgetContainer">
            <div className="header">
                <span className="headerText">
                    <span
                        className="live">{!isLiveEvent ? 'Final Results' : 'Live Leaderboard'} {currentEvent?.name}</span>
                </span>
            </div>
            <div className="contentContainer">
                {currentEvent && currentEvent.regattaId ? <ResultsTable eventId={currentEvent?.regattaId}/> :
                    <div>Leaderboard not setup yet for this past event</div>}
            </div>
        </div>
    );
};


export default ResultsWidget;